import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Deeplinks } from '@ionic-native/deeplinks';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { UniqueDeviceID } from '@ionic-native/unique-device-id';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SwingModule } from 'angular2-swing';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { CalendarModule } from 'ion2-calendar';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { IonicSelectableModule } from 'ionic-selectable';
import { Ionic2RatingModule } from 'ionic2-rating';
import { SuperTabsModule } from 'ionic2-super-tabs';
import { AgendamentoProvider } from '../providers/agendamento/agendamento';
import { Util } from '../providers/base/util';
import { BeneficiarioProvider } from '../providers/beneficiario/beneficiario';
import { DataProvider } from '../providers/data/data';
import { DeviceProvider } from '../providers/device/device';
import { EspecialidadeMedicaProvider } from '../providers/especialidade-medica/especialidade-medica';
import { ExameProvider } from '../providers/exame/exame';
import { InterceptedHttpProvider } from '../providers/intercepted-http/intercepted-http';
import { LocalidadeProvider } from '../providers/localidade/localidade';
import { PrestadorServicoProvider } from '../providers/prestador-servico/prestador-servico';
import { RotinaProvider } from '../providers/rotina/rotina';
import { MyApp } from './app.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
registerLocaleData(ptBr);
@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    HttpClientModule,
    SwingModule,
    SuperTabsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot(MyApp, {
      menuType: 'overlay'
    }),
    Ionic2RatingModule,
    IonicImageViewerModule,
    CalendarModule,
    IonicSelectableModule,
    BrMaskerModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    Util,
    DeviceProvider,
    StatusBar,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptedHttpProvider,
      multi: true
    },
    UniqueDeviceID,
    { provide: LOCALE_ID, useValue: 'pt' },
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    HttpClient,
    DataProvider,
    BeneficiarioProvider,
    PrestadorServicoProvider,
    EspecialidadeMedicaProvider,
    LocalidadeProvider,
    RotinaProvider,
    AgendamentoProvider,
    ExameProvider,
    Deeplinks
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts